type CurrencyLocaleMapKey = keyof typeof currencyToLocaleMap;

const currencyToLocaleMap = {
  AED: 'ar-AE',
  AFN: 'fa-AF',
  ALL: 'sq-AL',
  AMD: 'hy-AM',
  ANG: 'nl-CW',
  AOA: 'pt-AO',
  ARS: 'es-AR',
  AUD: 'en-AU',
  AWG: 'nl-AW',
  AZN: 'az-AZ',
  BAM: 'bs-BA',
  BBD: 'en-BB',
  BDT: 'bn-BD',
  BGN: 'bg-BG',
  BHD: 'ar-BH',
  BIF: 'fr-BI',
  BMD: 'en-BM',
  BND: 'ms-BN',
  BOB: 'es-BO',
  BRL: 'pt-BR',
  BSD: 'en-BS',
  BTN: 'dz-BT',
  BWP: 'en-BW',
  BYN: 'be-BY',
  BZD: 'en-BZ',
  CAD: 'en-CA',
  CDF: 'fr-CD',
  CHF: 'de-CH',
  CLP: 'es-CL',
  CNY: 'zh-CN',
  COP: 'es-CO',
  CRC: 'es-CR',
  CUP: 'es-CU',
  CVE: 'pt-CV',
  CZK: 'cs-CZ',
  DJF: 'fr-DJ',
  DKK: 'da-DK',
  DOP: 'es-DO',
  DZD: 'ar-DZ',
  EGP: 'ar-EG',
  ERN: 'ti-ER',
  ETB: 'am-ET',
  EUR: 'de-DE', // or es-ES, fr-FR, etc.
  FJD: 'en-FJ',
  FKP: 'en-FK',
  FOK: 'fo-FO',
  GBP: 'en-GB',
  GEL: 'ka-GE',
  GGP: 'en-GG',
  GHS: 'en-GH',
  GIP: 'en-GI',
  GMD: 'en-GM',
  GNF: 'fr-GN',
  GTQ: 'es-GT',
  GYD: 'en-GY',
  HKD: 'zh-HK',
  HNL: 'es-HN',
  HRK: 'hr-HR',
  HTG: 'ht-HT',
  HUF: 'hu-HU',
  IDR: 'id-ID',
  ILS: 'he-IL',
  IMP: 'en-IM',
  INR: 'hi-IN',
  IQD: 'ar-IQ',
  IRR: 'fa-IR',
  ISK: 'is-IS',
  JEP: 'en-JE',
  JMD: 'en-JM',
  JOD: 'ar-JO',
  JPY: 'ja-JP',
  KES: 'sw-KE',
  KGS: 'ky-KG',
  KHR: 'km-KH',
  KID: 'en-KI',
  KMF: 'fr-KM',
  KRW: 'ko-KR',
  KWD: 'ar-KW',
  KYD: 'en-KY',
  KZT: 'kk-KZ',
  LAK: 'lo-LA',
  LBP: 'ar-LB',
  LKR: 'si-LK',
  LRD: 'en-LR',
  LSL: 'st-LS',
  LYD: 'ar-LY',
  MAD: 'ar-MA',
  MDL: 'ro-MD',
  MGA: 'mg-MG',
  MKD: 'mk-MK',
  MMK: 'my-MM',
  MNT: 'mn-MN',
  MOP: 'zh-MO',
  MRU: 'ar-MR',
  MUR: 'en-MU',
  MVR: 'dv-MV',
  MWK: 'ny-MW',
  MXN: 'es-MX',
  MYR: 'ms-MY',
  MZN: 'pt-MZ',
  NAD: 'en-NA',
  NGN: 'en-NG',
  NIO: 'es-NI',
  NOK: 'no-NO',
  NPR: 'ne-NP',
  NZD: 'en-NZ',
  OMR: 'ar-OM',
  PAB: 'es-PA',
  PEN: 'es-PE',
  PGK: 'en-PG',
  PHP: 'en-PH',
  PKR: 'ur-PK',
  PLN: 'pl-PL',
  PYG: 'es-PY',
  QAR: 'ar-QA',
  RON: 'ro-RO',
  RSD: 'sr-RS',
  RUB: 'ru-RU',
  RWF: 'rw-RW',
  SAR: 'ar-SA',
  SBD: 'en-SB',
  SCR: 'fr-SC',
  SDG: 'ar-SD',
  SEK: 'sv-SE',
  SGD: 'en-SG',
  SHP: 'en-SH',
  SLE: 'en-SL',
  SLL: 'en-SL',
  SOS: 'so-SO',
  SRD: 'nl-SR',
  SSP: 'en-SS',
  STN: 'pt-ST',
  SYP: 'ar-SY',
  SZL: 'en-SZ',
  THB: 'th-TH',
  TJS: 'tg-TJ',
  TMT: 'tk-TM',
  TND: 'ar-TN',
  TOP: 'to-TO',
  TRY: 'tr-TR',
  TTD: 'en-TT',
  TVD: 'en-TV',
  TWD: 'zh-TW',
  TZS: 'sw-TZ',
  UAH: 'uk-UA',
  UGX: 'sw-UG',
  USD: 'en-US',
  UYU: 'es-UY',
  UZS: 'uz-UZ',
  VES: 'es-VE',
  VND: 'vi-VN',
  VUV: 'bi-VU',
  WST: 'sm-WS',
  XAF: 'fr-CM',
  XCD: 'en-XC',
  XOF: 'fr-BJ',
  XPF: 'fr-XP',
  YER: 'ar-YE',
  ZAR: 'en-ZA',
  ZMW: 'en-ZM',
  ZWL: 'en-ZW',
};

function isSupportedCurrencyLocale(str: string): str is CurrencyLocaleMapKey {
  return str in currencyToLocaleMap;
}

export function getLocaleByCurrencyCode(
  currencyCode: string | CurrencyLocaleMapKey
): string {
  if (!isSupportedCurrencyLocale(currencyCode)) {
    throw new Error(`Unsupported currency ${currencyCode}`);
  }

  return currencyToLocaleMap[currencyCode];
}

function formatCurrency({
  amount,
  currency,
}: {
  amount?: number | string;
  currency: string | CurrencyLocaleMapKey;
}) {
  return Intl.NumberFormat(getLocaleByCurrencyCode(currency), {
    style: 'currency',
    currency,
  }).format(
    typeof amount === 'undefined' || Number.isNaN(amount) ? 0 : Number(amount)
  );
}

export default formatCurrency;
